export default __webpack_public_path__ + "static/media/backgroundmobile.35b92505.png";